import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Button from '../../Button';
import { SchoolContactLog } from '../../../models';

export default function SendPasswordButton({ id, schoolId, role }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [contactLog, setContactLog] = useState()
  const [getLog, setGetLog] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!getLog) return
    const inputs = document.querySelectorAll(`#${id} input`)
    const email = inputs[3].value

    if (email === '') {
      setGetLog(false);
      return;
    }

    SchoolContactLog
      .order({ createdAt: 'desc' })
      .where({ email: email.toLowerCase() })
      .first()
      .then((res) => setContactLog(res.data))
      .finally(() => {
        setGetLog(false)
        setError(false)
      })
  }, [getLog])

  const handleClick = () => {
    setIsSubmitting(true);

    const inputs = document.querySelectorAll(`#${id} input`);

    const firstName = inputs[1].value;
    const lastName = inputs[2].value;
    const email = inputs[3].value;

    axios
      .post('/admin/users/resend_password', {
        email,
        first_name: firstName,
        last_name: lastName,
        school_id: schoolId,
        role,
      }, {
        withCredentials: true,
      })
      .then((res) => console.log(res))
      .catch(() => setError(true))
      .finally(() => {
        setIsSubmitting(false)
        setGetLog(true)
      });
  }

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ position: 'absolute', top: '50%', left: 0, transform: 'translate(-95%, -50%)' }}>
        {error && !contactLog && (
          <div style={{ color: 'red' }}>Ensure first name, last name, and email are set</div>
        )}
        {!error && contactLog && (
          <div style={{ color: 'green' }}>Password sent: {new Date(Date.parse(contactLog.createdAt)).toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"})}</div>
        )}
      </div>
      <Button disabled={isSubmitting} rounded variant="primary" type="button" fullWidth onClick={handleClick}>Send Password</Button>
    </div>
  );
}
